import {
  EventName,
  FullyQualifiedMessageName,
  HawkEvent,
  WidgetVisibleData,
} from '../entry/sendEvent';

import { BaseEvent } from './BaseEvent';

export class WidgetVisible extends BaseEvent {
  hawkEvent: HawkEvent;

  constructor({ widget }: Pick<WidgetVisibleData, 'widget'>) {
    super();
    this.hawkEvent = {
      name: EventName.WIDGET_VISIBLE,
      fullyQualifiedMessageName: FullyQualifiedMessageName.WIDGET_VISIBLE,
      data: {
        fieWidgetsVersion: this.fieWidgetsVersion,
        context: {
          page: this.page,
          content: this.content,
          site: this.site,
          experiment: this.experiment,
          user: this.user,
        },
        visibleAt: new Date().toISOString(),
        widget,
      },
    };
  }
}
